export default "__VITE_ASSET__e14547fb__"